module.exports = __webpack_public_path__ + "img/C06TechReinforcedCart_ua.2d3b1de9.webp";